import {Field} from "formik";
import React, {useState} from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
    ACTION_BUTTON_TYPES as ABT,
    pushToParams,
    requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import MultiSelect from "../../components/form-fields/MultiSelect";
import { useTranslation } from 'react-i18next';                   /* Added Line */

export default function NewDemands(props) {
    const [showModal, setShowModal] = useState(false);
    const [configData, setConfigData] = useState(null);
    const [refreshList, setRefreshList] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);
    const [t, i18n] = useTranslation();         /* Added Line */

    const validationSchema = yup.object({
        name: yup.string().required("Gerekli alan."),
    });

    const arrangeBeforePersist = (values) => {
        let payload = {
            name: values.name,
            id: values.id,
            companyIds: values.companies,
            stId: values.stId || 90,
        };
        return payload;
    };

    const adaptDataForUpdate = (data) => {
        let adaptedData = {
            name: data.name,
            id: data.id,
            stId: data.stId,
            companies: data.companies.map(c => c.id),
        };
        setInitialValues(adaptedData);
    };

    const onUpdateButtonClicked = (selectedRow) => {
        setShowModal(true);
        setIsUpdating(true);
        setSelectedRow(selectedRow);
    };

    return (
        <Main>

            <div className="row">
                <div className="col-md-12">
                    <ListComponent
                        entityName=""
                        endpoint=""
                        keyField="id"
                        refreshList={refreshList}
                        columns={[
                            {
                                dataField: "islemno",
                                text: `${t("demandList.islemNo")}`,
                                sort: true,
                                headerStyle: {
                                    width: 64
                                  }
                            },
                            {
                                dataField: "grup",
                                text: `${t("demandList.grup")}`,
                                sort: true,
                            },
                            {
                                dataField: "grupsirketi",
                                text: `${t("demandList.grupSirketi")}`,
                                sort: true,
                            },
                            {
                                dataField: "departman",
                                text: `${t("demandList.departman")}`,
                                sort: true,
                            },
                            {
                                dataField: "gorevliavukat",
                                text: `${t("demandList.gorevliAvukat")}`,
                                sort: true,
                            },
                            {
                                dataField: "talepTur.talepTuru",
                                text: `${t("demandList.talepTuru")}`,
                                sort: true,
                            },
                            {
                                dataField: "dosyaturu",
                                text: `${t("demandList.dosyaTuru")}`,
                                sort: true,
                            },
                            {
                                dataField: "talepDurumu",
                                text: `${t("demandList.talepDurumu")}`,
                                sort: true,
                            },
                            {
                                dataField: "sonDurumu",
                                text: `${t("demandList.sonDurum")}`,
                                sort: true,
                            },
                            {
                                dataField: "konu",
                                text: `${t("demandList.konu")}`,
                                sort: true,
                            },
                            {
                                dataField: "ekleyen",
                                text: `${t("demandList.ekleyen")}`,
                                sort: true,
                            },
                            {
                                dataField: "tarih",
                                text: `${t("demandList.talepTarihi")}`,
                                sort: true,
                                headerStyle: {
                                    width: 80
                                  }
                            },
                            {
                                dataField: "started",
                                text: `${t("demandList.baslangicTarihi")}`,
                                sort: true,
                            },
                            {
                                dataField: "tdate",
                                text: `${t("demandList.tamamlamaTarhihi")}`,
                                sort: true,
                            },
                            {
                                dataField: "bedel",
                                text: `${t("demandList.bedel")}`,
                                sort: true,
                            },

                            {
                                dataField: "dil",
                                text: `${t("demandList.dil")}`,
                                sort: true,
                            },
                        ]}
                        actionButtonsObject={{
                            actions: [
                                // pushToParams(ABT.EDIT, onUpdateButtonClicked),
                            ],
                            generator: DefaultActionButtonGenerator,
                        }}
                    />
                </div>
            </div>
        </Main>
    );
}
